import React, { useRef, useCallback } from 'react';

function SearchBarNew({ onSearch, value, placeholder }) {
  const expandSearchRefBin = useRef(null);
  const debounceRef = useRef(null);

  const handleKeyPress = useCallback(
    (e) => {
      if (e.key === 'Enter') {
        e.preventDefault(); // Prevent form submission or URL change

        // Debounce logic
        if (debounceRef.current) {
          clearTimeout(debounceRef.current); // Clear any pending timeout
        }
        debounceRef.current = setTimeout(() => {
          onSearch(e); // Trigger the search logic
        }, 1000); // Adjust delay as needed (300ms in this case)
      }
    },
    [onSearch],
  );

  const handleIconBinClick = () => {
    // Add a class to the input on icon click
    expandSearchRefBin.current.classList.toggle('active-input');
  };

  return (
    <div ref={expandSearchRefBin} className="common-expand-search">
      <button type="button" onClick={handleIconBinClick} className="btn btn-toggle">
        <span className="sr-only">Search</span>
        <span className="icon-Magnifying-Glass-Solid" />
      </button>

      <input
        type="text"
        className="form-control f-16"
        onKeyDown={handleKeyPress}
        onChange={(e) => onSearch(e)}
        value={value}
        autoComplete="off"
        placeholder={placeholder}
      />
    </div>
  );
}

export default SearchBarNew;
